// Scherm inrichten in de ouderapp (team 2, feat/bord-widgets): Tablets > het bord > Scherm
// inrichten. Widgets van de actieve modules kiezen, maat en vormgeving, volgorde, voorbeeld en de
// ouder-PIN voor het aanpassen op het bord zelf. Je-vorm, kort, rustig (docs/DESIGN.md §2).
export const appBoardConfigNl = {
    open: 'Scherm inrichten',
    title: 'Scherm inrichten',
    intro: "Schuif de widgets in het raster en maak ze smaller, breder, lager of hoger: hoe groter, hoe meer ze laten zien. Een bord heeft tot 12 pagina's; op het bord veeg je opzij naar de volgende.",
    standard: 'Dit bord toont nu de standaard. Pas iets aan om je eigen indeling te maken.',
    onBoard: 'Op het bord',
    available: 'Toevoegen',
    nothingToAdd: 'Alle widgets van jullie modules staan er al op.',
    empty: 'Nog niets op deze pagina. Voeg hieronder iets toe.',
    size: 'Maat',
    style: 'Vormgeving',
    moveUp: '{name} omhoog',
    moveDown: '{name} omlaag',
    remove: '{name} weghalen',
    pageEarlier: '{name} naar voren',
    pageLater: '{name} naar achteren',
    pageRemove: '{name} weghalen',
    onPage: 'Op {name}',
    weekSketch: 'Agenda van de week',
    phoneHint: 'Verplaatsen en groter of kleiner maken gaat op een tablet of computer. Hier kies je wat er op elke pagina staat.',
    add: '{name} toevoegen',
    reset: 'Standaardindeling',
    save: 'Bewaren',
    saved: 'Bewaard. Het bord past zich binnen een minuut aan.',
    resetDone: 'De standaardindeling staat klaar. Bewaar om hem op het bord te zetten.',
    failed: 'Bewaren lukte niet. Probeer het zo opnieuw.',
    conflict: 'Dit bord is intussen gewijzigd, misschien op het bord zelf. De nieuwste indeling staat er nu.',
    preview: 'Voorbeeld',
    previewNote: 'Met voorbeeldgegevens; het bord gebruikt die van jullie.',
    screen: 'Scherm',
    screens: { large: 'iPad', wide: 'Brede tablet', compact: 'Kleine tablet' },
    gestureTitle: 'Aanpassen op het bord zelf',
    gestureBody: 'Tik drie keer snel op de klok van het bord en geef je ouder-PIN. Na een minuut zonder tikken sluit het vanzelf.',
    pinTitle: 'Mijn ouder-PIN',
    pinBody: 'Gebruik je eigen PIN. Elke ouder heeft een persoonlijke PIN.',
    pinLabel: 'Nieuwe ouder-PIN',
    pinSave: 'PIN bewaren',
    pinSaved: 'Je ouder-PIN is bewaard.',
    pinInvalid: 'Kies 4 tot 6 cijfers.',
    pinTaken: 'Deze pincode is al in gebruik door een andere ouder. Kies een andere.',
    back: 'Terug naar Tablets',
    names: {
        prayer: 'Gebedstijden',
        weather: 'Weer',
        tasks: 'Taken',
        rides: 'Brengen en halen',
        meals: 'Eten',
        upcoming: 'Binnenkort',
        messages: 'Berichten',
        memorize: "Soera's leren",
        dinner: 'Wie eet mee',
        bookings: 'Reserveren',
        precip: 'Neerslag',
        week: 'Week (min en max)',
        quran: 'Koran luisteren',
        todos: "To-do's",
        notes: 'Notities',
        // 0068: Gezond op gewicht.
        kompas: 'Gezond bezig (Gezond op gewicht)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'School (huiswerk en toetsen)',
        // 0062: module Jodendom.
        shabbat: 'Sjabbat en kalender',
        // 0061: Kerk & kalender.
        seasons: 'Kerk & kalender',
        // 0063: module Hindoeïsme.
        almanac: 'Panchang en feesten',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'Boodschappen',
        rewards: 'Beloningen',
        // 0075: Huisronde (module Eten).
        house_round: 'Huisronde',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'Wensen',
        photo: 'Foto (Fotolijst)',
        timer: 'Timer',
        cleaning: 'Schoonmaak',
        rotation: 'Beurtrooster',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'Klok',
        travel: 'Vertrek',
        stock: 'Voorraad',
        cookbook: 'Recepten',
        reminders: 'Herinneringen',
        checkin: 'Check-in',
        fasting: 'Vasten',
        growth: 'Groei',
        money: 'Geldzaken',
        expenses: 'Kosten delen',
        my_todos: "Privé to-do's",
        circle: 'Familiekring',
    },
    sizes: { S: 'Klein', M: 'Middel', L: 'Groot', XL: 'Extra groot' },
    sizeHints: {
        S: 'Het belangrijkste in één oogopslag',
        M: 'Vandaag',
        L: 'Vandaag en morgen, met meer detail',
        XL: 'Alles, op een breed scherm',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'Ophaaltijd tonen',
    ridesPickupHint: 'Bijvoorbeeld "Papa haalt 16:50". Uit: alleen wie haalt.',
    styles: {
        // Widget Foto.
        slideshow: 'Wisselt elke minuut',
        daily: 'Foto van de dag',
        no_pickup: 'Zonder ophaaltijd',
        list: 'Lijst',
        ring: 'Klok',
        compact: 'Compact',
        illustrated: 'Met plaatje',
        today: 'Alleen vandaag',
        bars: 'Staafjes',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'Over de opnames',
        aboutBody: 'Recitatie door {name}. Bron: {source}.',
        familyOnly: 'Er is geen licentie bekend: deze opnames zijn alleen voor jullie gezin.',
        none: 'Nog geen opnames voor jullie gezin.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'Lego-ruimteschip',
        wishBook: 'Dierenboek',
        wishSkates: 'Skeelers',
        choreBathroom: 'Badkamer',
        choreVacuum: 'Stofzuigen',
        choreBins: 'Vuilnis buiten zetten',
        photoCaption: 'Zomer aan zee',
        school: 'School',
        swimming: 'Zwemles',
        judo: 'Judo',
        brushTeeth: 'Tanden poetsen',
        packBag: 'Tas inpakken',
        makeBed: 'Bed opmaken',
        setTable: 'Tafel dekken',
        groceries: 'Boodschappen',
        birthday: 'Noor wordt 8',
        autumnBreak: 'Herfstvakantie',
        pasta: 'Pasta pesto',
        soup: 'Soep',
        curry: 'Curry',
        pancakes: 'Pannenkoeken',
        pizza: 'Pizza',
        stew: 'Stamppot',
        inHours: '{n} u',
        paintCupboard: 'Schoenenkast verven',
        fixBike: 'Fietsband plakken',
        clearGutter: 'Dakgoot schoonmaken',
        noteMilk: 'Melk is op',
        noteSwim: 'Zwemtas niet vergeten',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'Melk',
        bread: 'Brood',
        apples: 'Appels',
        cheese: 'Kaas',
        cinema: 'Bioscoop',
    },
};
//# sourceMappingURL=boardConfigApp.nl.js.map